import React from "react";
import AssignClientChart from "../custom/AssignClientChartButton";

import {
    Create,
    Edit,
    List,
    SimpleForm,
    Datagrid,
    TextField,
    Show,
    SimpleShowLayout,
    ReferenceArrayField,
    TextInput,
    EditButton,
    DeleteButton,
    useRecordContext,
} from "react-admin";

import { ReferenceArrayInput, FormDataConsumer } from "react-admin";
import { Link } from "react-router-dom";

import LargePagination from "../core/LargePagination";
import { LVEditToolbar, LVCreateToolbar } from "../core/toolbars";
import AutocompleteArray from "../custom/AutocompleteArray";

export const SiteGroupList = (props) => {
    return (
        <List title="All groups" perPage={500} pagination={<LargePagination />} {...props}>
            <Datagrid bulkActionButtons={false}>
                <TextField source="id" />
                <TextField source="site_group_name" />
                <EditButton />
                <DeleteButton />
            </Datagrid>
        </List>
    );
};

export const SiteGroupShow = (props) => {
    return (
        <Show {...props}>
            <SimpleShowLayout>
                <TextField source="id" />
                <TextField source="site_group_name" />
                <ReferenceArrayField label="" source="userIds" reference="portal/users">
                    <Datagrid>
                        <TextField label="First Name" source="firstname" />
                        <TextField label="Last Name" source="lastname" />
                        <TextField label="Username" source="username" />
                        <TextField label="User ID" source="id" />
                    </Datagrid>
                </ReferenceArrayField>
            </SimpleShowLayout>
        </Show>
    );
};

const textFieldStyle = {
    fontSize: 13,
};

const SiteGroupField = (props) => {
    const record = useRecordContext();

    return props.linkToSiteGroup ? (
        <Link label={props.label} to={"siteGroups/" + record.id}>
            <TextField style={textFieldStyle} source={props.source} />
        </Link>
    ) : (
        <TextField style={textFieldStyle} label={props.label} source={props.source} />
    );
};

const classes = {
    textInput: {
        display: "flex",
        width: "20rem",
    },
};

const GroupTitle = ({ record }) => {
    return <span>Group {record ? `"${record.site_group_name}"` : ""}</span>;
};

const validateGroupCreation = (values) => {
    const errors = {};

    if (!values.site_group_name || values?.site_group_name?.trim()?.length === 0) {
        errors.site_group_name = "The site group name is required";
    }

    return errors;
};

const CoreFields = (props) => {
    return (
        <>
            <TextInput label="Group Name" source="site_group_name" sx={props.classes.textInput} />
        </>
    );
};

export const SiteGroupCreate = (props) => (
    <Create title="Create Group" {...props}>
        <SimpleForm validate={validateGroupCreation} toolbar={<LVCreateToolbar />}>
            <div>Create new group</div>

            <CoreFields classes={classes} />

            <ReferenceArrayInput label="Sites" source="sites" reference="portal/sites" style={{ width: "100%" }}>
                <AutocompleteArray
                    setValueName="sites"
                    setValueFormat={(values) => values.map((s) => Number(s.split(":")[0])).sort()}
                    buildLabel={(s) => s.id + ": " + s.site_group_name + ` (${s.modelType})`}
                />
            </ReferenceArrayInput>
        </SimpleForm>
    </Create>
);

export const SiteGroupEdit = (props) => (
    <Edit title={<GroupTitle />} {...props}>
        <SimpleForm toolbar={<LVEditToolbar />}>
            <TextInput disabled source="id" />

            <CoreFields classes={classes} />

            <ReferenceArrayInput label="Sites" source="sites" reference="portal/sites" style={{ width: "100%" }}>
                <AutocompleteArray
                    setValueName="sites"
                    setValueFormat={(values) => values.map((s) => Number(s.split(":")[0])).sort()}
                    buildLabel={(s) => s.id + ": " + s.site_group_name + ` (${s.modelType})`}
                />
            </ReferenceArrayInput>

            <FormDataConsumer>
                {({ formData }) => (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            fontFamily: "Roboto",
                            position: "relative",
                            top: "-.5rem",
                            marginTop: "1.5rem",
                        }}
                    >
                        <AssignClientChart
                            getEntityIds={() => {
                                return { siteIds: formData.sites };
                            }}
                        />
                        <span style={{ marginLeft: ".5rem" }}>Assign Client Chart</span>
                    </div>
                )}
            </FormDataConsumer>
            <ReferenceArrayField label="" source="userIds" reference="portal/users">
                <Datagrid bulkActionButtons="false">
                    <TextField label="First Name" source="firstname" />
                    <TextField label="Last Name" source="lastname" />
                    <TextField label="Username" source="username" />
                    <TextField label="User ID" source="id" />
                </Datagrid>
            </ReferenceArrayField>
        </SimpleForm>
    </Edit>
);
